<template>
  <!-- Authors Table Card -->
  <div>
    <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: 0 }">
      <template #title>
        <a-row type="flex" align="middle" :gutter="[10,10]">
          <a-col :span="24" :md="5">
            <h5 class="font-semibold m-0">用户管理</h5>
          </a-col>
          <a-col :span="24" :md="19" class="u-toolbar">
            <a-input v-model="uSearch" placeholder="搜索账号 / 域名" allow-clear style="width:170px">
              <a-icon slot="prefix" type="search" />
            </a-input>
            <a-select v-model="statusFilter" style="width:110px">
              <a-select-option value="">全部状态</a-select-option>
              <a-select-option value="active">未过期</a-select-option>
              <a-select-option value="expired">已过期</a-select-option>
            </a-select>
            <a-select v-model="sortOrder" style="width:140px">
              <a-select-option value="asc">到期 近→远</a-select-option>
              <a-select-option value="desc">到期 远→近</a-select-option>
              <a-select-option value="">默认排序</a-select-option>
            </a-select>
            <a-select v-model="tgFilter" style="width:130px">
              <a-select-option value="">TG:全部</a-select-option>
              <a-select-option value="bound">已绑定TG</a-select-option>
              <a-select-option value="unbound">未绑定TG</a-select-option>
            </a-select>
            <a-button type="primary" class="add-shop" @click="() => (modal2Visible = true)">新增用户</a-button>
            <a-button type="default" @click="handleSaveUsers" :loading="saveLoading">保存用户</a-button>
          </a-col>
        </a-row>
      </template>
      <a-table :columns="columns" :data-source="displayData" :pagination="true" :rowClassName="rowClassName">
        <template slot="username" slot-scope="text, row">
          <div class="u-cell" :class="{ 'u-sub': row.role === 'sub_user' }">
            <span v-if="row.role === 'sub_user'" class="u-arrow">↳</span>
            <span class="u-name">{{ row.username }}</span>
            <a-tag v-if="row.role === 'sub_user'" color="orange" class="u-tag">子账号</a-tag>
            <a-tag v-else-if="subCount(row.username) > 0" color="blue" class="u-tag">主账号 · {{ subCount(row.username) }} 子</a-tag>
            <a-tooltip v-if="row.tg_bound" :title="'已绑定 Telegram 到期提醒' + (row.telegram_id ? '(ID: ' + row.telegram_id + ')' : '')">
              <a-tag color="cyan" class="u-tag u-tg"><a-icon type="bell" /> TG</a-tag>
            </a-tooltip>
            <a-tag v-if="row.plan_name" color="geekblue" class="u-tag">{{ row.plan_name }}</a-tag>
            <a-tag v-if="row.user_type === 'agent'" color="purple" class="u-tag">代理</a-tag>
            <span v-if="row.role === 'sub_user'" class="u-parent">父：{{ row.parent }}</span>
          </div>
        </template>
        <template slot="author" slot-scope="author">
          <div class="table-avatar-info">
            <a-avatar shape="square" :src="author.avatar" />
            <div class="avatar-info">
              <h6>{{ author.name }}</h6>
              <p>{{ author.email }}</p>
            </div>
          </div>
        </template>
        <template slot="website" slot-scope="website">
          <div class="website-tags">
            <a-tooltip v-for="domain in website.split(',').filter(Boolean)" :key="domain" :title="domain + ' （点击复制）'">
              <a-tag class="website-tag" color="blue" @click="copyDomain(domain)">{{ domain }}</a-tag>
            </a-tooltip>
          </div>
        </template>
        <template slot="expiry_time" slot-scope="expiry_time">
          <div class="author-info">
            <h6 class="m-0" :class="{ 'text-red': isExpiringSoon(expiry_time) }">{{ expiry_time }}</h6>
          </div>
        </template>


        <template slot="status" slot-scope="status, row">
          <a-tag class="tag-status" :class="isActive(status, row.expiry_time) ? 'ant-tag-primary' : 'ant-tag-expired'">
            {{ isActive(status, row.expiry_time) ? "未过期" : "已过期" }}
          </a-tag>
        </template>

        <template slot="cloak" slot-scope="cloak">
          <a-tag class="tag-status" :class="cloak ? 'ant-tag-success' : 'ant-tag-default'">
            {{ cloak ? "已开启" : "已关闭" }}
          </a-tag>
        </template>

        <template slot="editBtn" slot-scope="row">
          <div style="white-space: pre">
            <a-button type="link" :data-id="row.key" class="btn-edit" @click="truePass(row)">
              真实密码
            </a-button>
            <a-button type="link" :data-id="row.key" class="btn-edit" @click="openEdit(row)">
              编辑用户
            </a-button>
            <a-button type="link" :data-id="row.key" class="btn-edit" @click="toggleCloak(row)">
              {{ row.cloak ? '关闭斗篷' : '开启斗篷' }}
            </a-button>
            <a-button type="link" :data-id="row.key" class="btn-edit" @click="openEditPass(row)">
              修改密码
            </a-button>
            <a-button type="link" :data-id="row.key" class="btn-edit" @click="openEditDays(row)">
              续期
            </a-button>
            <a-popconfirm title="确定要删除此用户吗?" ok-text="确定" cancel-text="取消" @confirm="deleteUser(row)">
              <a-button type="link" :data-id="row.key" style="color:red;">
                删除
              </a-button>
            </a-popconfirm>

          </div>
        </template>
      </a-table>
    </a-card>
    <!-- 新增用户 -->
    <a-modal v-model="modal2Visible" title="新增用户" centered cancelText="取消" okText="确认" @ok="addUser">
      <a-form-model :model="form">
        <a-form-model-item label="账号（aegis 开头）">
          <a-input-group compact>
            <a-input v-model="form.username" style="width: calc(100% - 96px)" placeholder="如 aegis123456" />
            <a-button style="width:96px" @click="genUsername">随机生成</a-button>
          </a-input-group>
        </a-form-model-item>
        <a-form-model-item ref="name" label="密码" prop="password">
          <a-input-group compact>
            <a-input v-model="form.password" style="width: calc(100% - 96px)" placeholder="可点右侧随机生成" />
            <a-button style="width:96px" @click="genPassword">随机生成</a-button>
          </a-input-group>
        </a-form-model-item>
        <a-form-model-item label="分配域名">
          <a-select v-model="form.website" placeholder="请选择分配域名" mode="multiple">
            <a-select-option v-for="domain in domains" :key="domain" :value="domain">
              {{ domain }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="套餐">
          <a-select v-model="form.plan_id" placeholder="选择套餐(选中会自动带出到期时间)" allowClear @change="onPlanChange">
            <a-select-option v-for="p in plans" :key="p.id" :value="p.id">
              {{ p.name }}（{{ p.price }}u / {{ p.days }}天 / {{ p.domains }}托管位）
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="用户类型">
          <a-select v-model="form.user_type" style="width:100%">
            <a-select-option value="normal">普通用户</a-select-option>
            <a-select-option value="agent">代理用户（有到期提醒，但不显示套餐续费/价格/联系方式）</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="到期时间">
          <a-date-picker v-model="date1" show-time type="date" placeholder="Pick a date" style="width: 100%" />
        </a-form-model-item>
        <a-form-model-item :style="{ marginBottom: 0 }">
          <a-button block icon="copy" @click="copyOpenInfo">复制开通信息（域名 / 后台 / 账号 / 密码）</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 分配域名 -->
    <a-modal v-model="editUserVisible" title="编辑用户" centered cancelText="取消" okText="确认" @ok="editUser">
      <a-form-model :model="form">
        <a-form-model-item label="用户昵称">
          <a-input v-model="editForm.username" disabled="true" @blur="
            () => {
              $refs.name.onFieldBlur();
            }
          " />
        </a-form-model-item>
        <a-form-model-item label="分配域名">
          <a-select v-model="editForm.website" :value="editForm.website" placeholder="请选择分配域名" mode="multiple">
            <a-select-option v-for="domain in domains" :key="domain" :value="domain">
              {{ domain }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="用户类型">
          <a-select v-model="editForm.user_type" style="width:100%">
            <a-select-option value="normal">普通用户</a-select-option>
            <a-select-option value="agent">代理用户（有到期提醒，但不显示套餐续费/价格/联系方式）</a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 修改密码 -->
    <a-modal v-model="editPassVisible" title="修改密码" centered cancelText="取消" okText="确认" @ok="editUser">
      <a-form-model :model="form">
        <a-form-model-item label="用户昵称">
          <a-input v-model="editForm.username" disabled="true" @blur="
            () => {
              $refs.name.onFieldBlur();
            }
          " />
        </a-form-model-item>
        <a-form-model-item ref="name" label="用户密码" prop="password">
          <a-input v-model="editForm.password" @blur="
            () => {
              $refs.name.onFieldBlur();
            }
          " />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 续期 -->
    <a-modal v-model="editDaysVisible" title="续期" centered cancelText="取消" okText="确认" @ok="editUser">
      <a-form-model :model="form">
        <a-form-model-item label="用户昵称">
          <a-input v-model="editForm.username" disabled="true" @blur="
            () => {
              $refs.name.onFieldBlur();
            }
          " />
        </a-form-model-item>
        <a-form-model-item label="到期时间">
          <a-date-picker v-model="editForm.days" show-time type="date" placeholder="Pick a date" style="width: 100%" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 斗篷确认 -->
    <a-modal v-model="cloakConfirmVisible" :title="cloakTitle" centered cancelText="取消" okText="确认" @ok="updateCloak">
      <p>{{ cloakConfirmText }}</p>
    </a-modal>
  </div>

  <!-- / Authors Table Card -->
</template>

<script>
import moment from "moment";
import { domainlist, register, updateuser, deleteuser, adminLogin, saveUsers } from "@/api/user";
import { planListAll } from "@/api/index";

export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },
  },
  created() {
    this.getAllDoamins();
    this.loadPlans();
  },
  data() {
    return {
      // Active button for the "Authors" table's card header radio button group.
      authorsHeaderBtns: "all",
      uSearch: "",
      statusFilter: "",
      sortOrder: "asc",
      tgFilter: "",
      modal2Visible: false,
      editUserVisible: false,
      editPassVisible: false,
      editDaysVisible: false,
      cloakConfirmVisible: false,
      cloakTitle: "",
      cloakConfirmText: "",
      domains: [],
      plans: [],
      date1: "",
      saveLoading: false,
      form: {
        username: "",
        days: "",
        password: "",
        website: [],
        cloak: false,
        plan_id: "",
        plan_name: "",
        user_type: "normal",
      },
      editForm: {
        username: "",
        website: [],
        password: "",
        days: "",
        cloak: false,
        user_type: "normal",
      },
    };
  },
  computed: {
    // 过滤(搜索 + 过期状态)+ 按到期时间排序;分页交给 a-table 的 :pagination
    displayData() {
      let arr = Array.isArray(this.data) ? this.data.slice() : [];
      const kw = (this.uSearch || "").trim().toLowerCase();
      if (kw) {
        arr = arr.filter((r) => {
          const web = Array.isArray(r.website) ? r.website.join(",") : (r.website || "");
          return ((r.username || "") + " " + web + " " + (r.parent || "")).toLowerCase().indexOf(kw) !== -1;
        });
      }
      if (this.statusFilter) {
        arr = arr.filter((r) => {
          const active = this.isActive(r.status, r.expiry_time);
          return this.statusFilter === "active" ? active : !active;
        });
      }
      if (this.tgFilter) {
        arr = arr.filter((r) => this.tgFilter === "bound" ? !!r.tg_bound : !r.tg_bound);
      }
      // 分组:子账号排在父账号之下
      const isSub = (r) => r.role === "sub_user" || (r.parent && r.parent !== "");
      const parents = arr.filter((r) => !isSub(r));
      const subs = arr.filter((r) => isSub(r));
      if (this.sortOrder) {
        const isExp = (r) => isNaN(Date.parse(r.expiry_time)); // 已过期/无效日期
        const val = (r) => Date.parse(r.expiry_time);
        parents.sort((a, b) => {
          const ea = isExp(a), eb = isExp(b);
          if (ea && !eb) return 1;   // 已过期一律沉底
          if (!ea && eb) return -1;
          if (ea && eb) return 0;
          return this.sortOrder === "asc" ? val(a) - val(b) : val(b) - val(a);
        });
      }
      const byParent = {};
      subs.forEach((s) => {
        const p = s.parent || "__orphan__";
        (byParent[p] = byParent[p] || []).push(s);
      });
      const parentNames = {};
      parents.forEach((p) => (parentNames[p.username] = true));
      const out = [];
      parents.forEach((p) => {
        out.push(p);
        (byParent[p.username] || []).forEach((s) => out.push(s));
      });
      // 父账号不在当前筛选结果里的子账号,单独排在末尾
      Object.keys(byParent).forEach((pn) => {
        if (!parentNames[pn]) byParent[pn].forEach((s) => out.push(s));
      });
      return out;
    },
  },
  watch: {
    date1(newDate) {
      if (newDate) {
        this.calculateDaysDifference(newDate);
      }
    },
  },
  methods: {
    subCount(username) {
      if (!Array.isArray(this.data)) return 0;
      return this.data.filter((r) => r.role === "sub_user" && r.parent === username).length;
    },
    rowClassName(row) {
      return row.role === "sub_user" ? "sub-user-row" : "";
    },
    // Handle page change
    handlePageChange(page) {
      this.currentPage = page;
    },
    setModal1Visible(modal1Visible) {
      this.modal1Visible = modal1Visible;
    },
    calculateDaysDifference(date) {
      // 传绝对到期时间(选中日期当天 23:59:59),避免天数截断少一天
      const selectedDate = moment(date).endOf("day");
      this.form.expiry = selectedDate.unix();
      this.form.days = Math.max(1, selectedDate.diff(moment(), "days"));
    },
    getAllDoamins() {
      domainlist().then((res) => {
        this.domains = res.data.available_domains;
      });
    },
    loadPlans() {
      planListAll().then((res) => {
        this.plans = (res && res.data) ? res.data : [];
      }).catch(() => {});
    },
    // 选择套餐：记录 plan_name,并按套餐时长自动带出到期时间
    onPlanChange(id) {
      const p = this.plans.find((x) => x.id === id);
      this.form.plan_name = p ? p.name : "";
      if (p && p.days > 0) {
        this.date1 = moment().add(p.days, "days");
      }
    },
    // 随机生成账号：aegis + 6 位数字
    genUsername() {
      let s = "";
      for (let i = 0; i < 6; i++) s += Math.floor(Math.random() * 10);
      this.form.username = "aegis" + s;
    },
    // 随机生成密码：10 位大小写字母 + 数字
    genPassword() {
      const chars = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789";
      let s = "";
      for (let i = 0; i < 10; i++) s += chars.charAt(Math.floor(Math.random() * chars.length));
      this.form.password = s;
    },
    // 复制开通信息(域名/后台链接/账号/密码)
    copyOpenInfo() {
      const uname = (this.form.username || "").trim();
      const pwd = (this.form.password || "").trim();
      if (!uname || !pwd) {
        this.$message.warning("请先填写/生成账号和密码");
        return;
      }
      const list = Array.isArray(this.form.website)
        ? this.form.website
        : (this.form.website ? [this.form.website] : []);
      const domainLines = list.length ? list.map((d) => "https://" + d).join("\n") : "（未选择域名）";
      const text =
        "域名:\n" + domainLines + "\n" +
        "后台链接:\n" + "https://svip.iiil.me\n" +
        "账号：\n" + uname + "\n" +
        "默认密码：\n" + pwd;
      const ok = () => this.$message.success("开通信息已复制");
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(ok).catch(() => this.fallbackCopyText(text, ok));
      } else {
        this.fallbackCopyText(text, ok);
      }
    },
    fallbackCopyText(text, done) {
      const ta = document.createElement("textarea");
      ta.value = text;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
      if (done) done();
    },
    addUser() {
      // 验证必填字段
      if (!this.form.username || !this.form.username.trim()) {
        this.$message.error("请输入用户昵称！");
        return;
      }
      if (!/^aegis/i.test(this.form.username.trim())) {
        this.$message.error("账号必须以 aegis 开头！");
        return;
      }
      if (!this.form.password || !this.form.password.trim()) {
        this.$message.error("请输入用户密码！");
        return;
      }
      if (!this.date1) {
        this.$message.error("请选择到期时间！");
        return;
      }
      if (this.form.days <= 0) {
        this.$message.error("到期时间必须大于当前时间！");
        return;
      }
      
      console.log(this.form);
      register(this.form).then((res) => {
        if (res.status === 200) {
          this.modal2Visible = false;
          this.$message.success("新增用户成功！");
          // 重置表单
          this.form = {
            username: "",
            days: "",
            password: "",
            website: [],
            cloak: false,
            plan_id: "",
            plan_name: "",
            user_type: "normal",
          };
          this.date1 = "";
          this.$emit("getUsers");
        } else {
          this.$message.error(res.message || "新增用户失败！");
        }
      }).catch((err) => {
        this.$message.error("新增用户失败：" + (err.message || "未知错误"));
      });
    },
    editUser() {
      let updateForm = {}
      updateForm.username = this.editForm.username;
      if (this.editForm.days != "") {
        // 传绝对到期时间(选中日期当天 23:59:59),后端按"到期-现在"算,避免少一天
        const selectedDate = moment(this.editForm.days).endOf("day");
        updateForm.expiry = selectedDate.unix();
        updateForm.days = Math.max(1, selectedDate.diff(moment(), "days")); // 兼容旧后端
      }
      switch (this.modalTitle) {
        case "编辑用户":
          updateForm.website = this.editForm.website
          updateForm.user_type = this.editForm.user_type
          break;
        case "编辑密码":
          updateForm.password = this.editForm.password
          break;
        case "斗篷设置":
          updateForm.cloak = this.editForm.cloak
          break;
      }

      updateuser(updateForm).then((res) => {
        this.editUserVisible = false;
        this.editPassVisible = false;
        this.editDaysVisible = false;
        this.$message.success("修改成功！");
        this.$emit("getUsers");
      });
    },
    deleteUser(row) {
      console.log(row)
      deleteuser({ username: row.username }).then((res) => {
        if (res.status != 200) return this.$message.error("删除失败！");
        this.$message.success("删除成功！");
        this.$emit("getUsers");
      });

    },
    openEdit(row) {

      this.modalTitle = "编辑用户";
      this.editForm.website = row.website.length ? row.website.split(",") : [];
      this.editForm.username = row.username;
      this.editForm.user_type = row.user_type || "normal";
      this.editUserVisible = true;
    },
    openEditPass(row) {
      this.modalTitle = "编辑密码";
      this.editForm.username = row.username;
      this.editForm.website = row.website.length ? row.website.split(",") : [];
      this.editPassVisible = true
    },
    openEditDays(row) {
      this.modalTitle = "续期";
      this.editForm.username = row.username;
      this.editForm.website = row.website.length ? row.website.split(",") : [];
      this.editDaysVisible = true
    },
    isExpiringSoon(expiry_time_str) {
      // 将到期时间字符串转换为日期对象
      let expiryDate = new Date(expiry_time_str);

      // 获取当前时间
      let currentDate = new Date();

      // 计算到期时间与当前时间的时间差（毫秒数）
      let timeDifference = expiryDate.getTime() - currentDate.getTime();

      // 将时间差转换为天数
      let daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

      // 判断是否低于7天
      return daysDifference < 7;
    },
    // 判断用户是否未过期
    isActive(status, expiry_time) {
      // 如果有 status 字段，直接使用
      if (status === 'active') return true;
      if (status === 'expired') return false;
      
      // 如果没有 status 字段，根据 expiry_time 判断
      if (expiry_time === '已过期') return false;
      
      // 根据时间判断
      let expiryDate = new Date(expiry_time);
      let currentDate = new Date();
      return expiryDate.getTime() > currentDate.getTime();
    },
    truePass(row) {
      adminLogin({ username: row.username }).then(res => {
        if (res.status == 200) {
          const token = res.data.token
          window.open(process.env.VUE_APP_URL.replace("/api","/dashboard") + "?token=" + token)
        }

      })
    },
    copyDomain(domain) {
      navigator.clipboard.writeText(domain).then(() => {
        this.$message.success('域名已复制到剪贴板');
      }).catch(() => {
        this.$message.error('复制失败，请手动复制');
      });
    },
    toggleCloak(row) {
      this.editForm.username = row.username;
      this.editForm.cloak = !row.cloak;
      this.modalTitle = "斗篷设置";
      this.cloakTitle = this.editForm.cloak ? "开启斗篷" : "关闭斗篷";
      this.cloakConfirmText = this.editForm.cloak 
        ? `确定要为用户 ${row.username} 开启斗篷吗？` 
        : `确定要为用户 ${row.username} 关闭斗篷吗？`;
      this.cloakConfirmVisible = true;
    },
    updateCloak() {
      let updateForm = {
        username: this.editForm.username,
        cloak: this.editForm.cloak
      };
      
      updateuser(updateForm).then((res) => {
        this.cloakConfirmVisible = false;
        this.$message.success(this.editForm.cloak ? "斗篷已开启！" : "斗篷已关闭！");
        this.$emit("getUsers");
      }).catch(err => {
        this.$message.error("操作失败！");
      });
    },
    // 保存所有用户到 JSON 文件
    handleSaveUsers() {
      this.saveLoading = true;
      saveUsers().then((res) => {
        if (res.status === 200) {
          this.$message.success(`保存成功！共保存 ${res.data.saved_count} 个用户`);
        } else {
          this.$message.error("保存失败！");
        }
      }).catch(err => {
        this.$message.error("保存失败：" + (err.message || "未知错误"));
      }).finally(() => {
        this.saveLoading = false;
      });
    },
  },
  mounted() {
    this.getAllDoamins();
  },
};
</script>
<style lang="css" scoped>
.btn-edit {
  color: blue;
}

.text-red {
  color: red;
}

.website-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  max-height: 88px;
  overflow-y: auto;
  padding-right: 2px;
}
.website-tags::-webkit-scrollbar { width: 6px; }
.website-tags::-webkit-scrollbar-thumb { background: #d9d9d9; border-radius: 3px; }

.website-tag {
  cursor: pointer;
  margin: 0;
  padding: 1px 7px;
  border-radius: 4px;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: all 0.3s;
}

.website-tag:hover {
  opacity: 0.8;
}

.ant-tag-success {
  color: #52c41a;
  background: #f6ffed;
  border-color: #b7eb8f;
}

.ant-tag-default {
  color: #d9d9d9;
  background: #fafafa;
  border-color: #d9d9d9;
}

.ant-tag-expired {
  color: #ff4d4f;
  background: #fff2f0;
  border-color: #ffccc7;
}
.u-toolbar {
  display: flex; align-items: center; justify-content: flex-end;
  gap: 10px; flex-wrap: wrap;
}
.u-cell { display: flex; align-items: center; gap: 6px; flex-wrap: wrap; }
.u-cell.u-sub { padding-left: 22px; }
.u-arrow { color: #bfbfbf; margin-left: -16px; margin-right: 2px; }
.u-name { font-weight: 600; }
.u-tag { border: none; border-radius: 6px; }
.u-parent { color: #8c8c8c; font-size: 12px; }
.sub-user-row { background: #fafbff; }
.sub-user-row:hover { background: #f0f5ff; }
</style>
